import { FormGroup, InputGroup, Switch } from '@blueprintjs/core';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import {
  ProjectFileUploadOptions,
  defaultProjectFileUploadOptions,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

type ProjectFileUploadOptionsFormProps = {
  fileOptions: ProjectFileUploadOptions;
  disableEditing?: boolean;
  disableHeaderToggle?: boolean;
  onSetFileOptions: (fileOptions: ProjectFileUploadOptions) => void;
};

export const ProjectFileUploadOptionsForm: React.VFC<
  ProjectFileUploadOptionsFormProps
> = ({
  fileOptions,
  disableEditing,
  disableHeaderToggle,
  onSetFileOptions,
}) => (
  <div className="sd-project-file-upload-options">
    <FormGroup
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form
          .separator
      }
      labelFor="sd-project-file-upload-options-separator"
    >
      <InputGroup
        disabled={disableEditing}
        id="sd-project-file-upload-options-separator"
        name="separator"
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
          onSetFileOptions({
            ...fileOptions,
            separator: evt.target.value,
          });
        }}
        placeholder={defaultProjectFileUploadOptions.separator}
        value={fileOptions.separator}
      />
    </FormGroup>
    <FormGroup
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form.quote
      }
      labelFor="sd-project-file-upload-options-quote"
    >
      <InputGroup
        disabled={disableEditing}
        id="sd-project-file-upload-options-quote"
        name="quote"
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
          onSetFileOptions({
            ...fileOptions,
            quote: evt.target.value,
          });
        }}
        placeholder={defaultProjectFileUploadOptions.quote}
        value={fileOptions.quote}
      />
    </FormGroup>
    <FormGroup
      label={
        copy.components.projectResourceDialog.projectFileUploadPanel.form.escape
      }
      labelFor="sd-project-file-upload-options-escape"
    >
      <InputGroup
        disabled={disableEditing}
        id="sd-project-file-upload-options-escape"
        name="escape"
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
          onSetFileOptions({
            ...fileOptions,
            escape: evt.target.value,
          });
        }}
        placeholder={defaultProjectFileUploadOptions.escape}
        value={fileOptions.escape}
      />
    </FormGroup>
    <FormGroup>
      <Tooltip
        content={
          copy.components.projectResourceDialog.projectFileUploadPanel.form
            .duplicateHeaders
        }
        disabled={disableEditing || !disableHeaderToggle}
      >
        <Switch
          checked={fileOptions.header}
          disabled={disableEditing || disableHeaderToggle}
          id="sd-project-file-upload-options-header"
          inline
          labelElement={
            <label htmlFor="sd-project-file-upload-options-header">
              {
                copy.components.projectResourceDialog.projectFileUploadPanel
                  .form.header
              }
            </label>
          }
          name="header"
          onChange={() => {
            onSetFileOptions({
              ...fileOptions,
              header: !fileOptions.header,
            });
          }}
        />
      </Tooltip>
    </FormGroup>
    <FormGroup>
      <Switch
        checked={fileOptions.skipEmpty}
        disabled={disableEditing}
        id="sd-project-file-upload-options-skip-empty"
        inline
        labelElement={
          <label htmlFor="sd-project-file-upload-options-skip-empty">
            {
              copy.components.projectResourceDialog.projectFileUploadPanel.form
                .skipEmpty
            }
          </label>
        }
        name="skipEmpty"
        onChange={() => {
          onSetFileOptions({
            ...fileOptions,
            skipEmpty: !fileOptions.skipEmpty,
          });
        }}
      />
    </FormGroup>
  </div>
);
